export default "__VITE_ASSET__DkauaMPU__"